import React from 'react';
import { HashRouter, Route, Routes } from 'react-router';

import { SignIn } from './Pages/SignIn';
import { Home } from './Pages/Home';
import { About } from './Pages/About';
import { Direction } from './Pages/Direction';
import { WogaaLayer } from './Services/wogaa-layer';
import { Frame } from './Pages/Frame';
import { EventTriggeredSentimentsPopUp } from './Pages/EventTriggeredSentimentsPopUp';
import { ErrorMonitor } from './Pages/ErrorMonitor';
import NotFound from './NotFound';

import './App.css';

function App() {
  return (
    <>
      <div id="searchsg-searchbar"></div>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Direction />} />
          <Route path="/wogaaLayer" element={<WogaaLayer />} />
          <Route path="/frame" element={<Frame />} />
          <Route path="/sign" element={<SignIn />} />
          <Route path="/home" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/event-triggered-sentiments-pop-up"
            element={<EventTriggeredSentimentsPopUp />}
          />
          <Route
            path="/error-monitor"
            element={<ErrorMonitor />}
          />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
